import {Exclude, Expose, instanceToPlain, plainToInstance, Transform, Type} from "class-transformer";
import * as t from "io-ts";
import {validateJSON, validateJSONNow} from "../web/validation";
import {CargoSubtype, toCargoSubtype} from "./cargo-subtype";
import {getDatabaseCodeTransformer} from "./transfomers/transformers";
import {Default} from "../util/decorators";
import {
  ExceedsNonPrimaryVolumeStatisticsSnapshotEntryArrayValidator,
  ExceedsNonPrimaryVolumeStatisticsSnapshotEntryEntity
} from "./exceeds-non-primary-volume-statistics-snapshot-entry";
import {TimeGroup, toTimeGroup} from "./time-group";

export const ExceedsNonPrimaryVolumeStatisticsSnapshotValidator = t.intersection([
  t.type({
    objectId: t.string,
    cargoSubtype: t.string,
    objectType: t.string,
    timeGroup: t.string,
    regionId: t.string,
  }),
  t.partial({
    objectName: t.string,
    volumeUnitOfMeasure: t.string,
    entries: ExceedsNonPrimaryVolumeStatisticsSnapshotEntryArrayValidator,
  }),
]);

export const ExceedsNonPrimaryVolumeStatisticsSnapshotArrayValidator = t.array(ExceedsNonPrimaryVolumeStatisticsSnapshotValidator);

export type ExceedsNonPrimaryVolumeStatisticsSnapshot = t.TypeOf<typeof ExceedsNonPrimaryVolumeStatisticsSnapshotValidator>;
export type ExceedsNonPrimaryVolumeStatisticsSnapshotArray = t.TypeOf<typeof ExceedsNonPrimaryVolumeStatisticsSnapshotArrayValidator>;

@Exclude()
export class ExceedsNonPrimaryVolumeStatisticsSnapshotEntity {
  @Expose()
  objectId!: string;

  @Expose()
  objectName?: string;

  @Expose()
  objectType!: string;

  @Expose()
  regionId!: string;

  @Expose()
  @Transform(getDatabaseCodeTransformer(toCargoSubtype))
  cargoSubtype!: CargoSubtype

  @Expose()
  volumeUnitOfMeasure?: string;

  @Expose()
  @Transform(getDatabaseCodeTransformer(toTimeGroup))
  timeGroup!: TimeGroup

  @Expose()
  @Type(() => ExceedsNonPrimaryVolumeStatisticsSnapshotEntryEntity)
  @Default([])
  entries: ExceedsNonPrimaryVolumeStatisticsSnapshotEntryEntity[] = [];

  /**
   * Constructor for ExceedsNonPrimaryVolumeStatisticsSnapshotEntity.
   * @hideconstructor
   */
  constructor() {
    // Empty constructor for 'class-transformer'
  }

  static from(containerExceedsNonPrimaryVolumeStatisticsGroup: ExceedsNonPrimaryVolumeStatisticsSnapshot): ExceedsNonPrimaryVolumeStatisticsSnapshotEntity {
    return plainToInstance(
      ExceedsNonPrimaryVolumeStatisticsSnapshotEntity,
      containerExceedsNonPrimaryVolumeStatisticsGroup,
      {
        excludeExtraneousValues: true,
      }
    );
  }

  loadTypeValue(): Promise<ExceedsNonPrimaryVolumeStatisticsSnapshot> {
    const object = instanceToPlain(this, {
      excludeExtraneousValues: true,
    });
    return validateJSON(ExceedsNonPrimaryVolumeStatisticsSnapshotValidator, object);
  }

  asTypeValue(): ExceedsNonPrimaryVolumeStatisticsSnapshot {
    const object = instanceToPlain(this, {
      excludeExtraneousValues: true,
    });
    return validateJSONNow(ExceedsNonPrimaryVolumeStatisticsSnapshotValidator, object);
  }
}
